"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchDigestPreferencesDtoModeEnum = void 0;
exports.instanceOfPatchDigestPreferencesDto = instanceOfPatchDigestPreferencesDto;
exports.PatchDigestPreferencesDtoFromJSON = PatchDigestPreferencesDtoFromJSON;
exports.PatchDigestPreferencesDtoFromJSONTyped = PatchDigestPreferencesDtoFromJSONTyped;
exports.PatchDigestPreferencesDtoToJSON = PatchDigestPreferencesDtoToJSON;
exports.PatchDigestPreferencesDtoToJSONTyped = PatchDigestPreferencesDtoToJSONTyped;
/**
 * @export
 */
exports.PatchDigestPreferencesDtoModeEnum = {
    Merge: 'merge',
    Replace: 'replace'
};
/**
 * Check if a given object implements the PatchDigestPreferencesDto interface.
 */
function instanceOfPatchDigestPreferencesDto(value) {
    if (!('selectedSports' in value) || value['selectedSports'] === undefined)
        return false;
    if (!('sportAnswers' in value) || value['sportAnswers'] === undefined)
        return false;
    return true;
}
function PatchDigestPreferencesDtoFromJSON(json) {
    return PatchDigestPreferencesDtoFromJSONTyped(json, false);
}
function PatchDigestPreferencesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectedSports': json['selectedSports'],
        'sportAnswers': json['sportAnswers'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'removedSportCodes': json['removedSportCodes'] == null ? undefined : json['removedSportCodes'],
    };
}
function PatchDigestPreferencesDtoToJSON(json) {
    return PatchDigestPreferencesDtoToJSONTyped(json, false);
}
function PatchDigestPreferencesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'selectedSports': value['selectedSports'],
        'sportAnswers': value['sportAnswers'],
        'mode': value['mode'],
        'removedSportCodes': value['removedSportCodes'],
    };
}
